var _defs, _sodipodiNamedview, _style, _g, _defs2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroidLogo2023Stacked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 624.79999 383.10001",
    xmlSpace: "preserve",
    id: "svg5",
    sodipodiDocname: "Android_logo_2023_(stacked).svg",
    width: 624.79999,
    height: 383.10001,
    inkscapeVersion: "1.3 (0e150ed6c4, 2023-07-21)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs5"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview5",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    inkscapeZoom: 1.2488636,
    inkscapeCx: 311.88353,
    inkscapeCy: 96.88808,
    inkscapeWindowWidth: 1728,
    inkscapeWindowHeight: 992,
    inkscapeWindowX: -8,
    inkscapeWindowY: -8,
    inkscapeWindowMaximized: 1,
    inkscapeCurrentLayer: "svg5"
  })), "&#10;", _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style1"
  }, "&#10;\t.st0{fill:#202124;}&#10;\t.st1{clip-path:url(#SVGID_00000034055883123690639930000008886705830115718281_);}&#10;\t.st2{fill:#34A853;}&#10;")), "&#10;", _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(-128.1,-189)"
  }, "&#10;\t", /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, "&#10;\t\t", /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 680.5,285.9 c 0,-16.4 11.9,-29.4 26.9,-29.4 15,0 26,12.6 26,29.4 0,16.8 -11.1,29.8 -26,29.8 -14.9,0 -26.9,-13.2 -26.9,-29.8 z M 629,331.7 h 21 v -91.4 h -21 z m -3.3,-121.9 c 0,7.9 6.4,14.3 13.9,14.3 7.5,0 13.7,-6.4 13.7,-14.3 0,-7.3 -6.2,-13.5 -13.7,-13.5 -7.5,0 -13.9,6.2 -13.9,13.5 z m -82.4,75.9 c 0,-16.4 12.1,-29.2 27.6,-29.2 15.5,0 27.6,12.8 27.6,29.2 0,16.4 -12.2,30 -27.6,30 -15.4,-0.1 -27.6,-13.4 -27.6,-30 z m -21.4,0 c 0,27.4 21.6,49 49,49 27.4,0 49,-21.6 49,-49 0,-27.4 -21.2,-48.2 -49,-48.2 -27.8,-0.1 -49,20.9 -49,48.2 z m -56.8,46 h 21 v -47.9 c 0,-19 10.1,-27.4 26.9,-27.4 3.1,0 5.5,0.2 7.7,0.7 v -18.5 c -2.2,-0.7 -6,-1.3 -10.2,-1.3 -28.5,0 -45.3,17.9 -45.3,46.4 v 48 z m -84.3,-45.8 c 0,-16.4 11.9,-29.4 26.9,-29.4 15,0 26,12.6 26,29.4 0,16.8 -11.1,29.8 -26,29.8 -14.9,0 -26.9,-13.2 -26.9,-29.8 z m -21.4,0 c 0,26.5 21.2,48.8 46.2,48.8 10.4,0 19.9,-4.2 25.6,-11.1 h 0.9 v 8.2 h 21 V 189 h -21 v 58.8 h -0.9 c -5.5,-6.6 -15,-10.4 -25.6,-10.4 -25.1,0 -46.2,22.1 -46.2,48.5 z m -92.1,45.8 h 21 v -53.5 c 0,-12.8 8.6,-21.7 20.5,-21.7 11.9,0 20.5,9 20.5,21.7 v 53.5 h 21 v -53.5 c 0,-22.3 -17.7,-40.8 -41.5,-40.8 -23.8,0 -41.5,18.5 -41.5,40.8 z M 170.8,276.9 193.5,212 h 1.1 l 22.7,64.9 z m -42.7,54.8 h 23.8 l 11.9,-34 h 60.7 l 11.9,34 H 260 L 207.2,189 h -26.3 z m 577.3,3 c 10.4,0 19.9,-4.2 25.6,-11.1 h 0.9 v 8.2 h 21 V 189 h -21 v 58.8 H 731 c -5.5,-6.6 -15,-10.4 -25.6,-10.4 -25.2,0 -46.2,22.1 -46.2,48.4 0,26.4 21.2,48.9 46.2,48.9 z",
    id: "path1"
  }), "&#10;\t"), "&#10;")), "&#10;", /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(-128.1,-189)"
  }, "&#10;\t", /*#__PURE__*/React.createElement("g", {
    id: "g5"
  }, "&#10;\t\t", _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, "&#10;\t\t\t", /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 275.29999,
    y: 379.60001,
    width: 330.5,
    height: 192.5
  }), "&#10;\t\t")), "&#10;\t\t", /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099632906935527403410000002792636259776861355_"
  }, "&#10;\t\t\t", /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    },
    id: "use1"
  }), "&#10;\t\t"), "&#10;\t\t", _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_00000099632906935527403410000002792636259776861355_)",
    id: "g4"
  }, "&#10;\t\t\t", /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 604.9,564.8 c -0.1,-0.7 -0.2,-1.3 -0.3,-2 -0.7,-4.1 -1.5,-8.2 -2.5,-12.3 -1.7,-7.1 -3.9,-14 -6.5,-20.6 -2.2,-5.7 -4.7,-11.2 -7.5,-16.5 -3.6,-6.8 -7.6,-13.4 -12.1,-19.7 -5.5,-7.7 -11.6,-14.8 -18.2,-21.5 -2.8,-2.8 -5.7,-5.5 -8.7,-8 -6.5,-5.6 -13.4,-10.7 -20.7,-15.2 0.1,-0.1 0.1,-0.2 0.2,-0.3 3.3,-5.8 6.7,-11.5 10,-17.3 3.3,-5.6 6.5,-11.2 9.8,-16.9 2.3,-4 4.7,-8.1 7,-12.1 0.6,-1 1,-1.9 1.3,-3 0.9,-2.8 1,-5.8 0.2,-8.6 -0.2,-0.7 -0.4,-1.4 -0.7,-2 -0.3,-0.7 -0.6,-1.3 -1,-1.9 -1.2,-2.1 -3,-3.9 -5.3,-5.2 -2,-1.2 -4.2,-1.9 -6.5,-2.1 -1,-0.1 -1.9,-0.1 -2.9,0 -0.8,0.1 -1.6,0.2 -2.3,0.4 -2.8,0.7 -5.3,2.2 -7.3,4.4 -0.7,0.8 -1.4,1.7 -1.9,2.6 -2.3,4 -4.7,8.1 -7,12.1 l -9.8,16.9 c -3.3,5.8 -6.7,11.5 -10,17.3 -0.4,0.6 -0.7,1.3 -1.1,1.9 -0.5,-0.2 -1,-0.4 -1.5,-0.6 -18.4,-7 -38.3,-10.8 -59.2,-10.8 -0.6,0 -1.1,0 -1.7,0 -18.5,0.2 -36.3,3.4 -53,9.2 -1.9,0.7 -3.8,1.4 -5.7,2.1 -0.3,-0.6 -0.7,-1.2 -1,-1.8 -3.3,-5.8 -6.7,-11.5 -10,-17.3 -3.3,-5.6 -6.5,-11.2 -9.8,-16.9 -2.3,-4 -4.7,-8.1 -7,-12.1 -0.6,-1 -1.2,-1.8 -1.9,-2.6 -2,-2.2 -4.6,-3.7 -7.3,-4.4 -0.8,-0.2 -1.6,-0.3 -2.3,-0.4 -1,-0.1 -1.9,-0.1 -2.9,0 -2.3,0.2 -4.5,0.9 -6.5,2.1 -2.2,1.3 -4,3.1 -5.3,5.2 -0.4,0.6 -0.7,1.2 -1,1.9 -0.3,0.7 -0.5,1.3 -0.7,2 -0.7,2.8 -0.7,5.7 0.2,8.6 0.3,1 0.8,2 1.3,3 2.3,4 4.7,8.1 7,12.1 3.3,5.6 6.5,11.2 9.8,16.9 3.3,5.8 6.7,11.5 10,17.3 0,0 0.1,0.1 0.1,0.1 -6.7,4.2 -13.1,8.8 -19.2,13.9 -3.6,3 -7.1,6.2 -10.4,9.5 -6.7,6.6 -12.7,13.8 -18.2,21.5 -4.5,6.3 -8.5,12.8 -12.1,19.7 -2.8,5.3 -5.3,10.8 -7.5,16.5 -2.6,6.7 -4.8,13.6 -6.5,20.6 -1,4 -1.8,8.1 -2.5,12.3 -0.1,0.7 -0.2,1.3 -0.3,2 -0.4,2.4 -0.7,4.8 -1,7.3 h 330.5 c 0,-2.5 -0.3,-4.9 -0.6,-7.3 z",
    id: "path2"
  }), "&#10;\t\t\t", /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 526.5,526.3 c 6.6,-4.4 7.6,-14.6 2.1,-22.7 -5.4,-8.2 -15.2,-11.2 -21.8,-6.8 -6.6,4.4 -7.6,14.6 -2.1,22.7 5.4,8.2 15.2,11.2 21.8,6.8 z",
    id: "path3"
  }), "&#10;\t\t\t", /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 376.7,519.6 c 5.4,-8.2 4.5,-18.3 -2.1,-22.7 -6.6,-4.4 -16.4,-1.4 -21.8,6.8 -5.4,8.2 -4.5,18.3 2.1,22.7 6.6,4.4 16.3,1.3 21.8,-6.8 z",
    id: "path4"
  }), "&#10;\t\t")), "&#10;\t"), "&#10;"), "&#10;");
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidLogo2023Stacked);
export default __webpack_public_path__ + "static/media/Android_logo_2023_(stacked).34fc6b8f97292cd44ee6473d2993a50a.svg";
export { ForwardRef as ReactComponent };